import React from "react";
import Skeleton from "react-loading-skeleton";

const CartPanelItemSkeleton: React.FC = () => {
  return (
    <li className="cart-panel-item">
      <div className="cart-panel-item__image">
        <Skeleton height={80} width={80} />
      </div>
      <div className="cart-panel-item__details">
        {/* Skeleton for name and meta */}
        <div>
          <Skeleton width="90%" />
          <Skeleton width="60%" style={{ marginTop: "0.25rem" }} />
        </div>
        {/* Skeleton for the footer elements */}
        <div className="cart-panel-item__footer">
          <Skeleton height={32} width={50} />
          <Skeleton height={32} width={100} />
          <Skeleton height={32} width={50} />
        </div>
      </div>
    </li>
  );
};

export default CartPanelItemSkeleton;
